/**
 * StingBase
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type ReconstructionDocumentationEnum = 1 | 2 | 3 | 4;

export const ReconstructionDocumentationEnum = {
    NUMBER_1: 1 as ReconstructionDocumentationEnum,
    NUMBER_2: 2 as ReconstructionDocumentationEnum,
    NUMBER_3: 3 as ReconstructionDocumentationEnum,
    NUMBER_4: 4 as ReconstructionDocumentationEnum
};

